import React, { PureComponent } from 'react'
import { Guardian } from '@xaamin/guardian';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, Button, ButtonToolbar } from 'react-bootstrap';

class RetencionesToolbarActions extends PureComponent {

  handleOnToggleSelectableItems = () => {
    this.props.onToggleSelectableItems();
  }

  goToComprobanteCreatePage = () => {
    this.props.history.push('/app/retenciones/timbrado')
  }

  render() {
    return (
      <ButtonToolbar className="d-inline-flex">
        <ButtonGroup>
          { Guardian.allows('retencion.crear') &&
            <Button variant="primary" className="mr-2" onClick={ this.goToComprobanteCreatePage }>
              <FontAwesomeIcon icon={ ['fas', 'plus'] } />
              { ' ' } Retención
            </Button>
          }
          <Button variant="secondary" onClick={ this.handleOnToggleSelectableItems }>
            <FontAwesomeIcon icon={ ['fas', 'check'] } />
          </Button>
          <Button variant="secondary" className="mr-2">
            <FontAwesomeIcon icon={ ['fas', 'sliders-h'] } />
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    )
  }
}

export default withRouter(RetencionesToolbarActions);